export interface PlanogramPreviewTarget {
  type: "base" | "store";
  id: number;
}

export interface PlanogramPreviewRequestCoordinator {
  runLatestRequest: <Response>(
    target: PlanogramPreviewTarget,
    request: () => Promise<Response>,
  ) => Promise<Response | null>;
  cancelPendingRequest: () => void;
  dispose: () => void;
}

export const createPlanogramPreviewRequestCoordinator = (
  setLoadingTarget: (target: PlanogramPreviewTarget | null) => void,
): PlanogramPreviewRequestCoordinator => {
  let latestRequestId = 0;
  let activeTarget: PlanogramPreviewTarget | null = null;

  return {
    runLatestRequest: async <Response>(
      target: PlanogramPreviewTarget,
      request: () => Promise<Response>,
    ) => {
      if (activeTarget?.type === target.type && activeTarget.id === target.id) {
        return null;
      }

      const requestId = ++latestRequestId;
      activeTarget = target;
      setLoadingTarget(target);

      try {
        const response = await request();
        return requestId === latestRequestId ? response : null;
      } finally {
        if (requestId === latestRequestId) {
          activeTarget = null;
          setLoadingTarget(null);
        }
      }
    },
    cancelPendingRequest: () => {
      latestRequestId++;
      activeTarget = null;
      setLoadingTarget(null);
    },
    dispose: () => {
      latestRequestId++;
      activeTarget = null;
    },
  };
};
